var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47355 10.5065L0.683594 20.1721C0.684419 20.1738 0.684419 20.1764 0.685245 20.1781C0.95521 21.2276 1.87986 22 2.97788 22C3.41709 22 3.82906 21.8768 4.18241 21.6613L4.21047 21.6442L14.1042 15.7294L9.47355 10.5065Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3656 8.85888L18.3573 8.8529L14.0857 6.28767L9.27344 10.7244L14.1031 15.7266L18.3515 13.187C19.0962 12.7696 19.6023 11.9561 19.6023 11.0187C19.6023 10.0863 19.1036 9.27715 18.3656 8.85888Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.682469 1.82697C0.629632 2.02884 0.601562 2.24097 0.601562 2.45994V19.5398C0.601562 19.7587 0.629632 19.9709 0.683295 20.1719L9.77459 10.7535L0.682469 1.82697Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53877 11L14.0877 6.28783L4.20552 0.351632C3.84639 0.128384 3.427 8.01086e-05 2.97871 8.01086e-05C1.88069 8.01086e-05 0.954384 0.774179 0.684419 1.82456C0.684419 1.82542 0.683594 1.82627 0.683594 1.82713L9.53877 11Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGstore);
export default __webpack_public_path__ + "static/media/gstore.d7dcf3b3c114cb32bad704f88a375f74.svg";
export { ForwardRef as ReactComponent };